<template>
  <div class="modal fade update-user-modal" id="UpdateUserModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar usuário</h1>
                  <button type="button" class="btn-close update-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateUser" @submit.prevent="updateUserMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para atualizar</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_user_update" class="form-label fw-medium"
                      >Nome</label
                    > 
                    <input
                      :value="getCurrentUpdateUser.name"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_user_update"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="cellphone_user_update" class="form-label fw-medium"
                      >Celular (opcional)</label
                    >                      
                      <input
                        :value="getCurrentUpdateUser.phone"
                        id="cellphone_user_update"
                        ref="cellphone_update"
                        type="text"
                        class="form-control shadow-none rounded-0 text-black radius-7"
                        placeholder="Digite o celular"
                        @keyup="changeInformationInputs('cellphone_update')"
                        @input="applyMaskPhone"
                        maxlength="15"
                      />
                  </div>

                  <!-- active/inactive flag -->
                  <div class="form-check mb-20 col-12">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="active_user_update"
                      v-model="isActive"
                    />
                    <label class="form-check-label" for="active_user_update">
                      Usuário ativo
                    </label>
                  </div>

                <!-- Horários de Trabalho -->
                <div class="mt-30">
                  <h5 class="mb-4">Horários de Trabalho</h5>
                  <div v-for="(day, index) in daysOfWeek" :key="day" class="mb-3">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'day_update_' + index"
                        v-model="workSchedule[index].active"
                      />
                      <label class="form-check-label fw-medium" :for="'day_update_' + index">
                        {{ day }}
                      </label>
                    </div>
                    <div v-if="workSchedule[index].active" class="ms-4">
                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <label :for="'start_update_' + index" class="form-label">Horário de início</label>
                          <input
                            type="time"
                            class="form-control"
                            :id="'start_update_' + index"
                            v-model="workSchedule[index].start_time"
                            required
                          />
                        </div>
                        <div class="col-md-6 mb-2">
                          <label :for="'end_update_' + index" class="form-label">Horário de fim</label>
                          <input
                            type="time"
                            class="form-control"
                            :id="'end_update_' + index"
                            v-model="workSchedule[index].end_time"
                            required
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <label :for="'lunch_start_update_' + index" class="form-label">Início do almoço (opcional)</label>
                          <input
                            type="time"
                            class="form-control"
                            :id="'lunch_start_update_' + index"
                            v-model="workSchedule[index].lunch_start"
                          />
                        </div>
                        <div class="col-md-6 mb-2">
                          <label :for="'lunch_end_update_' + index" class="form-label">Fim do almoço (opcional)</label>
                          <input
                            type="time"
                            class="form-control"
                            :id="'lunch_end_update_' + index"
                            v-model="workSchedule[index].lunch_end"
                          />
                        </div>
                      </div>
                    </div>
                    <hr v-if="index < daysOfWeek.length - 1" class="my-3">
                  </div>
                </div>

                <div class="mt-30 mb-4">
                  <h5 class="mb-3">Acesso as paginas</h5>
                  <div class="row">
                    <div
                      v-for="page in getAccessPages"
                      :key="page.key"
                      class="col-12 col-md-6 mb-2"
                    >
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'update_access_page_' + page.key"
                          :value="page.key"
                          v-model="selectedAllowedPages"
                          :disabled="isLoadingAccess"
                        />
                        <label class="form-check-label" :for="'update_access_page_' + page.key">
                          {{ page.label }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-30 mb-4">
                  <h5 class="mb-3">Usuarios que ele pode ver</h5>
                  <div class="row">
                    <div
                      v-for="user in getAllUsersList"
                      :key="user.id"
                      class="col-12 col-md-6 mb-2"
                    >
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'update_visible_user_' + user.id"
                          :value="Number(user.id)"
                          v-model="selectedVisibleUserIds"
                          :disabled="isLoadingAccess || Number(user.id) === Number(getCurrentUpdateUser.id)"
                        />
                        <label class="form-check-label" :for="'update_visible_user_' + user.id">
                          {{ user.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                  <label for="password_update" class="form-label fw-medium"
                    >Sua senha para confirmar</label
                  >
                  <input
                    type="password"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="password_update"
                    autocomplete="off"
                    required
                  />

                  <div class="form-text mb-15 mb-mb-15 mb-md-20 col-12">
                    Por segurança, precisamos que você confirme sua senha para realizar a alteração deste usuário.
                  </div>
                </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger update-user-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonUpdateUser" class="btn btn-success">Salvar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "UpdateUserModal",
  data () {
    return {
      selectedOperations: [],
      selectedRoleId: null,
      selectedAllowedPages: [],
      selectedVisibleUserIds: [],
      isLoadingAccess: false,
      // track whether the user is active or not
      isActive: false,
      daysOfWeek: ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'],
      dayMapping: {
        'Segunda-feira': 'MONDAY',
        'Terça-feira': 'TUESDAY',
        'Quarta-feira': 'WEDNESDAY',
        'Quinta-feira': 'THURSDAY',
        'Sexta-feira': 'FRIDAY',
        'Sábado': 'SATURDAY',
        'Domingo': 'SUNDAY'
      },
      workSchedule: [
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getCurrentUpdateUser",
      "getOperations",
      "getAccessPages",
      "getAllUsersList"
    ]),
  },
  watch: {
    // update phone mask when user phone changes
    'getCurrentUpdateUser.phone'(newValue) {
      this.$nextTick(() => {
        this.applyMaskPhone({
          target: this.$refs.cellphone_update
        });
      });
    },

    // initialize active checkbox when current user changes
    getCurrentUpdateUser(newVal) {
      this.fetchUserAccess(newVal);
      if(newVal && newVal.active !== undefined){
        this.isActive = (newVal.active === 1 || newVal.active === true || newVal.active === '1');
      }
      // Initialize work schedule if available
      if(newVal && newVal.working_hours) {
        this.workSchedule = this.daysOfWeek.map((day, index) => {
          const englishDay = this.dayMapping[day];
          const existing = newVal.working_hours.find(s => s.day_of_week === englishDay);
          return existing ? { 
            active: true, 
            start_time: existing.start_time ? existing.start_time.slice(0,5) : '', 
            lunch_start: existing.init_lunch ? existing.init_lunch.slice(0,5) : '', 
            lunch_end: existing.end_lunch ? existing.end_lunch.slice(0,5) : '', 
            end_time: existing.end_time ? existing.end_time.slice(0,5) : '' 
          } : { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' };
        });
      } else {
        // Reset to default
        this.workSchedule = this.daysOfWeek.map(() => ({ active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' }));
      }
    }
  },
  methods: {
    ...mapActions([
      "setAccessControl",
      "setAllUsersList"
    ]),
    async fetchUserAccess(user) {
      if(!user || !user.id){
        return;
      }

      this.isLoadingAccess = true;
      try {
        const response = await api.axios.get(`/api/users/${user.id}/access-control`);
        this.selectedAllowedPages = Array.isArray(response.data.allowed_pages) ? response.data.allowed_pages : [];
        this.selectedVisibleUserIds = Array.isArray(response.data.visible_user_ids)
          ? response.data.visible_user_ids.map((id) => Number(id))
          : [Number(user.id)];

        if(!this.selectedVisibleUserIds.includes(Number(user.id))){
          this.selectedVisibleUserIds.push(Number(user.id));
        }
      } catch(error) {
        console.log("error", error);
        this.selectedAllowedPages = this.getAccessPages.map((page) => page.key);
        this.selectedVisibleUserIds = [Number(user.id)];
      } finally {
        this.isLoadingAccess = false;
      }
    },
    async saveUserAccess(userId) {
      const visibleUserIds = [
        ...this.selectedVisibleUserIds.map((id) => Number(id)),
        Number(userId)
      ];

      await api.axios.post(`/api/users/${userId}/access-control`, {
        allowed_pages: this.selectedAllowedPages,
        visible_user_ids: [...new Set(visibleUserIds)]
      });
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    async updateUserMethod(){
      const alertResponse = this.alertResponse;

      const user_id = this.getCurrentUpdateUser.id;
      const name_user_update = document.getElementById("name_user_update").value;
      const cellphone_user_update = document.getElementById("cellphone_user_update").value;
      const password_update = document.getElementById("password_update").value;
      
      if(!name_user_update || !password_update){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const objUserUpdate = {
        "id": user_id,
        "name": name_user_update,
        "phone": cellphone_user_update,
        "password": password_update,
        "active": this.isActive ? 1 : 0,
        "working_hours": this.workSchedule.filter(schedule => schedule.active).map(schedule => {
          const day = this.daysOfWeek[this.workSchedule.indexOf(schedule)];
          return {
            day_of_week: this.dayMapping[day],
            start_time: schedule.start_time + ':00',
            init_lunch: schedule.lunch_start ? schedule.lunch_start + ':00' : null,
            end_lunch: schedule.lunch_end ? schedule.lunch_end + ':00' : null,
            end_time: schedule.end_time + ':00'
          };
        })
      }

      const buttonUpdateUser = this.$refs.buttonUpdateUser;
      buttonUpdateUser.disabled = true;
      buttonUpdateUser.innerHTML = "Salvando...";
      

      try {
        const response = await api.axios.post("/api/update/user", objUserUpdate);

        if(response != undefined && response.status == 200){
          buttonUpdateUser.innerHTML = "Salvando acessos...";
          await this.saveUserAccess(user_id);
          buttonUpdateUser.innerHTML = "Informacoes salvas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateUser.disabled = false;
          buttonUpdateUser.innerHTML = "Salvar";
        }
      } catch(error) {
        if(error.response && error.response.data != undefined){
          buttonUpdateUser.innerHTML = "Salvar";
        }
        console.log("error", error);
        buttonUpdateUser.disabled = false;
        alertResponse(error.response && error.response.data ? error.response.data : "Erro ao atualizar usuario", true);
      }
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_update");
      if(password){
        password.value = "";
      }
    },
  },
  mounted() {
    this.setAccessControl();
    this.setAllUsersList();
  }
};
</script>
